<template>
    <button v-if="quantity" @click="viewCart()">
        <i class="far fa-shopping-cart relative">
            <span
                class="
                    px-1
                    absolute
                    bg-green
                    text-2xs
                    font-bold
                    font-sans
                    text-center
                    rounded-full
                    text-green-100
                "
                style="
                    top: -0.5rem;
                    right: -0.5rem;
                    line-height: 1.3;
                "
            >
                {{ quantity }}
            </span>
        </i>
    </button>
</template>

<script>
export default {
    props: {
        itemCount: {
            default: 0,
            type: Number,
            required: false,
        }
    },

    data: function () {
        return {
            quantity: this.itemCount,
        };
    },

    mounted: function () {
        window.bus.$on('cart-quantity', quantity => {
            this.quantity = quantity;
        });
    },

    methods: {
        viewCart: function () {
            window.location.pathname.startsWith('/order')
                ? this.$router.push('/order/view')
                : window.location.href = '/order/view';
        },
    },
}
</script>
